<template>
    <div>
      <v-container>
    
       <v-row>
   
         <v-col cols="12">
                   <v-card elevation="1">
                  <v-toolbar elevation="0">
                    <v-icon left color="primary">mdi-text-box-multiple-outline</v-icon> My Jobs  <v-divider vertical inset class="ml-5 mr-2"/>
                    
                  
                  </v-toolbar>
                
                  <v-toolbar dense elevation="1" class="mt-2">
                  <div style="width: 290px;" class="mb-2">
                           <v-text-field
                               v-model="search"
                               append-icon="mdi-magnify"
                               label="Search"
                               single-line
                               dense
                               outlined
                               hide-details
                           ></v-text-field>
                    </div>
                     <v-spacer/>
                    <span style="width: 190px;" class="mr-2">
                           <v-menu
                                  ref="menu"
                                  v-model="menu"
                                  :close-on-content-click="false"
                                  :return-value.sync="date"
                                  transition="scale-transition"
                                  offset-y
                                  min-width="auto"
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                      v-model="from_date"
                                      label="From Date"
                                      single-line
                                       prepend-icon="mdi-calendar-month"
                               dense
                               outlined
                               hide-details
                                      readonly
                                      v-bind="attrs"
                                      v-on="on"
                                    ></v-text-field>
                                  </template>
                                  <v-date-picker
                                    v-model="from_date"
                                    no-title
                                    scrollable
                                    @input="menu = false"
                                  >
                                
                                  </v-date-picker>
                                </v-menu>
                    </span>
                    <span style="width: 190px;">
                           <v-menu
                                  ref="menu2"
                                  v-model="menu2"
                                  :close-on-content-click="false"
                                  :return-value.sync="date"
                                  transition="scale-transition"
                                  offset-y
                                  min-width="auto"
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                      v-model="to_date"
                                      label="To Date"
                                      single-line
                                       prepend-icon="mdi-arrow-right"
                               dense
                               outlined
                               hide-details
                                      readonly
                                      v-bind="attrs"
                                      v-on="on"
                                    ></v-text-field>
                                  </template>
                                  <v-date-picker
                                    v-model="to_date"
                                    no-title
                                    scrollable
                                    @input="menu2 = false, QrySales()"
                                  >
                                
                                  </v-date-picker>
                                </v-menu>
                    </span>
                  </v-toolbar>
                  <v-card-text  v-if="!IsEmpty(items)">

                      <v-row>
                    <v-col cols="12" sm="3">
                           <v-card tile>
                            <v-card-text class="pa-1">
                        
                            <table class="va-table">
                                <tr>
                                    <td class="text-center bg-success" width="90"> <v-icon center x-large color="white">mdi-currency-php</v-icon></td>
                                    <td class="text-center pa-2">
                                        <span class="text-h6 font-weight-bold">{{$money(SALES)}}</span>
                                        <v-divider />
                                        <span class="def-font text-success ">Total Sales</span>
                                    </td>
                                </tr>
                            </table>
                          </v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" sm="3">
                           <v-card tile>
                            <v-card-text class="pa-1">
                        
                            <table class="va-table">
                                <tr>
                                    <td class="text-center bg-info" width="90"> <v-icon center x-large color="white">mdi-account-hard-hat</v-icon></td>
                                    <td class="text-center pa-2">
                                        <span class="text-h6 font-weight-bold">{{$count(JOBORDER)}}</span>
                                        <v-divider />
                                        <span class="def-font text-info ">Job Orders</span>
                                    </td>
                                </tr>
                            </table>
                          </v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" sm="3">
                           <v-card tile>
                            <v-card-text class="pa-1">
                        
                            <table class="va-table">
                                <tr>
                                    <td class="text-center bg-success" width="90"> <v-icon center x-large color="white">mdi-application-cog</v-icon></td>
                                    <td class="text-center pa-2">
                                        <span class="text-h6 font-weight-bold">{{$count(INPROGRESS)}}</span>
                                        <v-divider />
                                        <span class="def-font text-success ">In Progress</span>
                                    </td>
                                </tr>
                            </table>
                          </v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" sm="3">
                           <v-card tile>
                            <v-card-text class="pa-1">
                        
                            <table class="va-table">
                                <tr>
                                    <td class="text-center bg-accent" width="90"> <v-icon center x-large color="white">mdi-book-cancel</v-icon></td>
                                    <td class="text-center pa-2">
                                        <span class="text-h6 font-weight-bold">{{$count(CANCELLED)}}</span>
                                        <v-divider />
                                        <span class="def-font text-accent ">Cancelled</span>
                                    </td>
                                </tr>
                            </table>
                          </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                
                  <table class="va-table va-table-border-bot mt-4" >
                     <tr>
                        <th width="30"></th>
                        <th>Number</th>
                        <th>Customer</th>
                        <th>Service Bay</th>
                        <th width="170">Date</th>
                        <th class="text-center">Status</th>
                        <th class="text-right">Amount</th>
                     </tr> 
                     <tr v-for="(item, index) in FILTEREDITEMS" :key="index">
                        <td class="text-center">
                          <v-icon small  @click="selectedID=item.id,state='modify',form=true">mdi-text-box-edit</v-icon></td>
                       
                        <td>
                            {{item.id}}
                        </td>
                        <td> {{item.customer_data.fullname}}</td>
                        <td> {{item.service_bay}}</td>
                          <td> {{$moment(item.created_at).format("YYYY-MM-DD HH:MM A")}}</td>
                        
                        <td :class="STATUS_BG(item.status)" class="text-center text-white">{{item.status}}</td>
                        <td class="text-right"> {{$money(item.total_amount)}}</td>
                     </tr>
                    
                  </table>
                 
                    <div class="pa-4">
                          <span class="mx-2">Item(s) Found: {{SEARCHFILTER.length}}</span>|
                          <span class="mx-2">
                            Rows per page: <select v-model="view.per_page" @change="view.current_page=1"  class="va-select">
                              <option v-for="fruit in [5,10,15,20,50,100,1000]" :key="fruit" :value="fruit">
                                {{ fruit }}
                              </option>
                            </select>
                          </span>
                          |
                            <span class="mx-2">
                            <v-icon left small @click="view.current_page>1?view.current_page=view.current_page-1:view.current_page=1">mdi-arrow-left</v-icon>
                            {{view.current_page}}/{{ PAGE_COUNT}}
                            <v-icon right small @click="view.current_page<PAGE_COUNT?view.current_page=view.current_page+1:view.current_page=PAGE_COUNT">mdi-arrow-right</v-icon>
                             </span>   
                    </div>
                     
                  </v-card-text>
                  <v-card-text class="text-center" v-else>
                          <div class="font-weight-thin font-italic pa-5 mt-5"  >
                            No data found..
                          </div>
                    </v-card-text>
             
                </v-card>
             </v-col>
       </v-row>
       </v-container>
        <va-sales-form :show="form" :selectedID="selectedID"  :state="state" @DialogEvent="formEvent" />
        
     </div>
   </template>
   <script>
   import {
     mapMutations
   } from 'vuex'
     export default {
       data: () => ({
           form: false,
           menu: false,
           menu2: false,
           date:"",
           from_date:"",
           to_date:'',
           search:"",
           selectedID:  null,
           trans_dailog: false,
           areaform: false,
           state: 'new',
           invetory:{},
           items:[],
           view: {
              per_page: 50,
              current_page: 1,
              pagination: true
           },
           USERID: 0,
       }),
       beforeCreate: function () {
         if (!this.$session.exists()) {
           this.$router.push('/')
         } 
       },
       created() {
          if (this.$session.exists()) {
             this.$http.defaults.headers.common['Authorization'] = 'Bearer ' + this.$session.get('jwt')
             this.setLoggedIn(true) 
            this.CHECKPAGEPERMISSION()
             this.SETVARS()
             this.USERID  = this.$IsNum(this.$session.get('userID'))
            this.getItems()
           }
       },
       computed:{
         FILTEREDITEMS(){
            if(this.items.length == 0) {
              return []
            }
            var pageArr = this.$pagination(this.SEARCHFILTER,this.view.per_page)
            return pageArr[this.view.current_page - 1]
         },
         PAGE_COUNT(){
          var pageArr = this.$pagination(this.SEARCHFILTER,this.view.per_page)
          return pageArr.length
         },
         SEARCHFILTER(){
            if(this.search != "") {
              return this.$crawler(this.items, this.search)
            } else {
              return this.items
            }
         },
           CANCELLED(){
            var total = this.items.reduce((res,item)=>{
              if(item.status == 'Cancelled')
                  res = this.$IsNum(res) +  1
                  return res
            }, 0)
            return total
          },
           INPROGRESS(){
            var total = this.items.reduce((res,item)=>{
              if(item.status == 'In Progress')
                  res = this.$IsNum(res) +  1
                  return res
            }, 0)
            return total
          },
          JOBORDER(){
            var total = this.items.reduce((res,item)=>{
              if(item.type == 'Job Order')
                  res = this.$IsNum(res) +  1
                  return res
            }, 0)
            return total
          },
        SALES(){
            var total = this.items.reduce((res,item)=>{
              if(item.status == 'Completed' && item.payment_status == 'Paid')
                  res = this.$IsNum(res) +  this.$IsNum(item.total_amount)
                  return res
            }, 0)
            return total
          },
       },
       methods: {
         ...mapMutations(['setAlert', 'setAlertColor', 'setAlertText', 'setLoggedIn','setVariables']),
       
        imagePreview(images){
          console.log("images",images)
         if(images == null) {
          return  this.$store.state.nopreview
         }
           if(images.length == 0) {
          return  this.$store.state.nopreview
         }
         let arr = this.ViewUploadedfiles(images)
         return arr[0]
        },
         formEvent(){
             this.form = false
             this.getItems()
         },
        QrySales(){
          if(this.IsEmpty(this.from_date)) {
            this.from_date = this.$moment().format('YYYY-MM-DD')
          }
           if(this.IsEmpty(this.to_date)) {
            this.to_date = this.$moment().format('YYYY-MM-DD')
          }
          
          this.VA_ALERT('info', 'Loading sales', 'progress', 100, 1500)
           this.items = []
            this.QUERY('sales',`select s.id,  s.service_bay, s.customer_data, s.created_at, s.status, s.type, s.invoice_no, s.total_amount, s.payment_status,s.discount_request 
from sales s left join users u on u.id=s.service_personnel 
where to_date(created_at::text,'YYYY-MM-DD') >= '${this.from_date}' and to_date(created_at::text,'YYYY-MM-DD') <= '${this.to_date}' and s.service_personnel=${this.USERID} and s.status='Completed' order by id desc`, (res)=>{
              console.log(res)
              this.items = res.results
            })
        },
         getItems: function() { 
          this.VA_ALERT('info', 'Loading sales', 'progress', 100, 1500)
           this.items = []
            this.QUERY('sales',`select s.id, s.service_bay,  s.customer_data, s.created_at, s.status, s.type, s.invoice_no, s.total_amount, s.payment_status,s.discount_request 
from sales s left join users u on u.id=s.service_personnel where s.service_personnel=${this.USERID} and s.status='Completed' order by id desc limit 200`, (res)=>{
              console.log(res)
              this.items = res.results
            })
        }
       }
     }
   </script>